const SESSION_STORAGE_KEY = 'reportedQuizQuestions';
export const getReportedQuestion = () => {
    return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));
};
export const saveReportedQuestion = (quizId, questionId) => {
    let reportedQuestions = getReportedQuestion();
    if (reportedQuestions) {
        reportedQuestions[quizId] ? reportedQuestions[quizId].push(questionId) : (reportedQuestions[quizId] = [questionId]);
    }
    else {
        reportedQuestions = {
            [quizId]: [questionId],
        };
    }
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(reportedQuestions));
};
export const getReportedQuestionsCount = (quizId) => {
    const reportedQuestions = getReportedQuestion();
    return (reportedQuestions === null || reportedQuestions === void 0 ? void 0 : reportedQuestions[quizId]) ? reportedQuestions[quizId].length : 0;
};
